import {TreeNode} from 'primeng/api';

export class TreeNodeHelper {
  static getMatchingNode<T>(element: T, node: TreeNode<T>): TreeNode<T> | null {
    const stack = [node];
    while (stack.length) {
      const node = stack.shift();
      if (node?.data === element) {
        return node;
      }
      if (node?.children) {
        node.children && stack.push(...node.children);
      }
    }
    return null;
  }
}
